import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { IntegrationLinhaProducaoSharedModule } from '../configuracoes/integration/linha-producao';
import { LinhaProducaoRoutingModule } from './linha-producao-routing.module';
import { LinhaProducaoComponent } from './linha-producao.component';
import { LinhaProducaoFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        LinhaProducaoRoutingModule,
        IntegrationLinhaProducaoSharedModule
    ],
    declarations: [
        LinhaProducaoComponent,
        LinhaProducaoFormComponent
    ]
})
export class LinhaProducaoModule { }
